import React, { useState } from "react";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState("idle"); // idle | sending | success | error
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    setErrorMessage("");

    try {
      const response = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.detail || "Something went wrong. Please try again.");
      }

      setStatus("success");
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      setStatus("error");
      setErrorMessage(err.message);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-lg mx-auto mt-6">
      <div className="flex flex-col gap-4 text-left">
        <div>
          <label htmlFor="contact-name" className="block text-sm font-medium text-txt-contrast mb-1">Name</label>
          <input
            id="contact-name"
            type="text"
            name="name"
            required
            value={formData.name}
            onChange={handleChange}
            className="w-full px-4 py-3 rounded-lg border border-border bg-bg-body2 text-txt-primary focus:outline-none focus:border-primary-main transition-colors"
          />
        </div>
        <div>
          <label htmlFor="contact-email" className="block text-sm font-medium text-txt-contrast mb-1">Email</label>
          <input
            id="contact-email"
            type="email"
            name="email"
            required
            value={formData.email}
            onChange={handleChange}
            className="w-full px-4 py-3 rounded-lg border border-border bg-bg-body2 text-txt-primary focus:outline-none focus:border-primary-main transition-colors"
          />
        </div>
        <div>
          <label htmlFor="contact-subject" className="block text-sm font-medium text-txt-contrast mb-1">Subject</label>
          <input
            id="contact-subject"
            type="text"
            name="subject"
            required
            value={formData.subject}
            onChange={handleChange}
            className="w-full px-4 py-3 rounded-lg border border-border bg-bg-body2 text-txt-primary focus:outline-none focus:border-primary-main transition-colors"
          />
        </div>
        <div>
          <label htmlFor="contact-message" className="block text-sm font-medium text-txt-contrast mb-1">Message</label>
          <textarea
            id="contact-message"
            name="message"
            required
            rows={5}
            value={formData.message}
            onChange={handleChange}
            className="w-full px-4 py-3 rounded-lg border border-border bg-bg-body2 text-txt-primary focus:outline-none focus:border-primary-main transition-colors resize-y"
          />
        </div>
        <button
          type="submit"
          disabled={status === "sending"}
          className="btn-theme self-center px-8 py-3 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {status === "sending" ? "Sending..." : "Send Message"}
        </button>
      </div>

      {status === "success" && (
        <p className="mt-4 text-center text-primary-main">
          Message sent successfully! I'll get back to you soon.
        </p>
      )}
      {status === "error" && (
        <p className="mt-4 text-center text-red-500">
          {errorMessage}
        </p>
      )}
    </form>
  );
};

export default ContactForm;
